import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
@Component({
  selector: "app-view-document",
  templateUrl: "./view-document.component.html",
  styleUrls: ["./view-document.component.scss"],
})
export class ViewDocumentComponent implements OnInit {
  activeLang: string = "en";
  constructor(public dialogRef: MatDialogRef<ViewDocumentComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    console.log(this.data);
  }
}
